import { render, staticRenderFns } from "./ActPoliticaPrivacidade.vue?vue&type=template&id=ea367904&scoped=true&"
import script from "./ActPoliticaPrivacidade.vue?vue&type=script&lang=js&"
export * from "./ActPoliticaPrivacidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea367904",
  null
  
)

export default component.exports